export type AiCostQuantitiesPayload = {
	readonly inputTokens: number;
	readonly outputTokens: number;
	readonly cachedInputTokens: number;
	readonly cacheWriteTokens: number;
	readonly totalTokens: number;
	readonly audioSeconds: number;
};

export type AiCostAmountPayload = {
	readonly amount: number;
	readonly unpricedCallCount: number | null;
};

export type AiCostAudioPayload = {
	readonly count: number;
	readonly durationSeconds: number;
	readonly cost: number;
	readonly unpricedCount: number;
};

export type AiCostDocumentsPayload = {
	readonly count: number;
	readonly cost: number;
	readonly unpricedCount: number;
};

export type AiCostSummaryFetchedPayload = {
	readonly period: { readonly from: string; readonly to: string };
	readonly previousPeriod: { readonly from: string; readonly to: string; readonly cost: number };
	readonly hasActivity: boolean;
	readonly callCount: number | null;
	readonly cost: AiCostAmountPayload;
	readonly audio: AiCostAudioPayload;
	readonly documents: AiCostDocumentsPayload;
	readonly quantities: AiCostQuantitiesPayload | null;
};

export type AiCostSummaryFetchedAction = {
	type: 'AI_COST_SUMMARY_FETCHED';
	payload: AiCostSummaryFetchedPayload;
	accountId: number;
	queryKey: string;
};

export default (
	payload: AiCostSummaryFetchedPayload,
	accountId: number,
	queryKey: string,
): AiCostSummaryFetchedAction => ({
	type: 'AI_COST_SUMMARY_FETCHED',
	payload,
	accountId,
	queryKey,
});
